import React from "react";

type Props = {
  title: string;
  subtitle?: string;
  right?: React.ReactNode;
};

export default function HandballHeader({ title, subtitle, right }: Props): JSX.Element {
  return (
    <div
      style={{
        background: "var(--surface-subtle)",
        border: "1px solid var(--border-subtle)",
        borderRadius: 14,
        padding: 12,
        margin: "4px 0 12px",
      }}
    >
      <div className="u-row" style={{ justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" as any }}>
        <div>
          <div style={{ fontWeight: 900, fontSize: 22, lineHeight: 1.1, color: "var(--text-brand)" }}>{title}</div>
          {subtitle && (
            <div style={{ marginTop: 2, fontSize: 13, color: "var(--text-secondary)" }}>{subtitle}</div>
          )}
        </div>
        {right && (
          <div className="u-row" style={{ gap: 10, alignItems: "center" }}>{right}</div>
        )}
      </div>
    </div>
  );
}


